import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "table-bg" }
const _hoisted_2 = { class: "p-d-flex p-ai-end" }

import { client } from '@/api/client-v2';
import { PaymentFilters, PaymentsResponse } from '@/api/types';
import { formatDate } from '@/services/dates.service';
import { useStore } from '@/store/store';
import Column from 'primevue/column';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import FilterPayments from './FilterPayments.vue';
import { MutationTypes } from '@/store/mutation-types';
import router from '@/router';


export default _defineComponent({
  setup(__props) {

const LIMIT = 15;
const payments = ref<PaymentsResponse['payments']>([]);
const total = ref(0);
const page = ref(1);
const loading = ref(false);
const first = computed(() => (page.value - 1) * LIMIT);
const sortBy = ref<'paymentDate' | 'bookingDate'>('paymentDate');
const sortDirection = ref<1 | -1>(-1);

const { t } = useI18n();
const store = useStore();

const filters = ref<PaymentFilters>({
  paymentDateFrom: undefined,
  paymentDateTo: undefined,
  bookingDateFrom: undefined,
  bookingDateTo: undefined,
  bookingStatus: undefined,
  paymentStatus: undefined,
  userId: undefined,
})

const getPayments = async () => {
  try {
    loading.value = true;
    const { data } = await client.getPaymentsWithFilters(store.getters.getMyClub.club_id, {
      ...filters.value,
      page: page.value,
      limit: LIMIT,
      sortBy: sortBy.value,
      sortDirection: sortDirection.value < 1 ? 'DESC' : 'ASC',
    });
    payments.value = [...data.payments];
    total.value = data.totalCount;
  } catch (error) {
    console.error('Error fetching users:', error);
    payments.value = [];
    total.value = 0;
    page.value = 1;
  } finally {
    loading.value = false;
  }
}

const paymentStatusLabel = (label: string) => {
  const statusLabels = {
    'ELABORATED': 'Completi e Falliti',
    'FAILED': 'Fallito',
    'SCHEDULED': 'Programmato',
    'CANCELLED': 'Cancellato',
    'COMPLETED': 'Completato'
  };

  return statusLabels[label] || ''
}

const bookingStateLabel = (label: string) => {
  const labels = {
    'CONFIRMED': 'Confermata',
    'CANCELLED': 'Cancellata'
  }
  return labels[label] || ''
}

const pageEvent = (event: { page: number }) => {
  // page 1 is returned as 0 here, so we need to add 1
  page.value = event.page + 1;
  getPayments();
}

const searchFromFirstPage = () => {
  page.value = 1;
  getPayments();
}

const sortEvent = (event: { sortField: string; sortOrder: -1 | 1 }) => {
  sortDirection.value = event.sortOrder;
  sortBy.value = event.sortField === 'bookingPayment.paidAt' ? 'paymentDate' : 'bookingDate';
  searchFromFirstPage();
}
const goToScheduler = (booking: PaymentsResponse['payments'][0]['booking']) => {
  store.commit(MutationTypes.SET_SCROLL_EVENT, { ...booking })
  nextTick(() => {
    router.push({ name: 'Scheduler' });
  })
}

onMounted(() => {
  searchFromFirstPage()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: payments.value,
      lazy: "",
      paginator: "",
      rows: 15,
      "page-link-size": 10,
      first: _unref(first),
      "total-records": total.value,
      loading: loading.value,
      "responsive-layout": "scroll",
      onPage: pageEvent,
      onSort: sortEvent,
      size: "large",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: "{first} a {last} di {totalRecords} pagamenti",
      paginatorPosition: "top",
      "sort-field": "bookingPayment.paidAt",
      "sort-order": sortDirection.value
    }, {
      paginatorLeft: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(FilterPayments, {
            filters: filters.value,
            "onUpdate:filters": [
              _cache[1] || (_cache[1] = ($event: any) => (filters.value = $event)),
              searchFromFirstPage
            ]
          }, null, 8, ["filters"])
        ])
      ]),
      empty: _withCtx(() => [
        _createVNode("p", null, _toDisplayString(_unref(t)('no_records')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "bookingPayment.paidAt",
          header: _unref(t)('payment_time'),
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            (['COMPLETED', 'FAILED', 'CANCELLED'].includes(slotProps.data.bookingPayment.status))
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.bookingPayment.updatedAt, "lll")), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.bookingPayment.dueDate, "lll")), 1)
                ], 64))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "bookingPayment.status",
          header: _unref(t)('payment_state_label')
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(paymentStatusLabel(slotProps.data.bookingPayment.status)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "booking.price",
          header: _unref(t)('price')
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.booking.price ? (slotProps.data.booking.price / 100).toFixed(2) : '') + " € ", 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "user.cognome",
          header: _unref(t)('user_id')
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_router_link, {
              to: { name: 'user-details', params: { id: slotProps.data.user.id } },
              class: "color-blue p-text-bold underline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.user.nome) + " " + _toDisplayString(slotProps.data.user.cognome), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "booking.date",
          header: _unref(t)('booking_date'),
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.booking.date, 'll')), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "booking.date",
          header: _unref(t)('start_hour')
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.booking.start_at, 'lll')), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "playground.name",
          header: _unref(t)('playground')
        }, null, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "booking.booking_state",
          header: _unref(t)('stato_prenotazione')
        }, {
          body: _withCtx((slotProps) => [
            _createVNode("button", {
              class: {
            'color-red': slotProps.data.booking.booking_state === 'CANCELLED',
            'color-green': slotProps.data.booking.booking_state === 'CONFIRMED'
          },
              onClick: () => goToScheduler(slotProps.data.booking)
            }, _toDisplayString(bookingStateLabel(slotProps.data.booking.booking_state)), 11, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "first", "total-records", "loading", "sort-order"])
  ]))
}
}

})